// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__2M8j6","content":"RecentSearches_content__ByWn0"};